/** Spinner de carga: span animado (.loader) usado como fallback de Suspense y en cargas puntuales. */
import "./spinner.css";

const Spinner = () => {
  return <span className="loader"></span>;
};

export default Spinner;
